
const setBaseURL = (api, URL) => {
    if (process.env.REACT_APP_STAGE === 'DEVELOPMENT') {
        api.defaults.baseURL = URL;
    }
}

export default setBaseURL;